/**
 * This Constant Object represents the page enumeration where the banner
 * must be shown. The values have to be aligned with the values for the
 * contentful field in the CTA Banners object, see:
 *
 * https://app.contentful.com/spaces/51b7jii69wp2/environments/development/content_types/ctaBanners/fields
 *
 * This is expected to grow in use, so if product or marketing aks for a new page,
 * it must be added here and has to match the given name in the content model.
 */
export const VisibleInFieldsValues = {
  FindNewRetailers: 'Find New Retailers',
  RetailCenter: 'Retail Center',
  OrderList: 'Order List',
  OrderReview: 'Order Review',
} as const

/**
 * This Constant Object represents the banner item layout to
 * be shown. The values have to be aligned with the values for the
 * contentful field in the CTA Banners Items object, see:
 *
 * https://app.contentful.com/spaces/51b7jii69wp2/environments/development/content_types/ctaBannerItem/fields
 *
 * This is expected to grow in use, so if product layout for the banner item,
 * it must be added here and has to match the given name in the content model.
 */
export const CTABannerLayoutValues = {
  default: 'default',
  inline: 'inline',
} as const

export const DEFAULT_START_COLOR = '#F9D8D1'
export const DEFAULT_END_COLOR = '#F9EFD4'

export const ERROR_MESSAGES = {
  NO_CTA_BANNERS_FOUND: '[CTA Banners] No CTA Banner Items found',
  ERROR_FETCHING_BANNERS: '[CTA Banners] Error fetching CTA Banners',
  ERROR_FETCHING_BANNER_ITEMS: '[CTA Banners] Error fetching CTA Banner Items',
  ERROR_FETCHING_GRADIENT_COLOR: '[CTA Banners] Error fetching Gradient Color',
} as const
